import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fixType'
})
export class FixTypePipe implements PipeTransform {
  transform(value: string): string {
    return value?.split('|')[0];
  }
}
